import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'swipeclock-frontend';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useHistory } from 'react-router-dom';
import { useLoginContext } from 'providers/LoginProvider';
import { ButtonSetWrapper } from '../shared/StyledComponents';

export default function BottomButtons({
  loginBag,
  submitting,
  handleLogin,
  isAutofilled = false,
}) {
  const { disabled, isValid } = loginBag;

  const history = useHistory();
  const {
    actions,
    meta: { pages },
  } = useLoginContext();
  const submitDisabled = !isAutofilled && (disabled || !isValid(pages.START));
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const handleForgotPassword = () => {
    actions.setCurrentPage(pages.FORGOTPASS);
    actions.setGlobalMessage();
    history.replace('/clock/web/login/password/forgot');
  };

  return (
    <>
      <ButtonSetWrapper spacing={0.5} direction="column" alignItems="center">
        <Button
          id="sc-login_button"
          size="large"
          sx={{ width: isMobile ? '100%' : '50%' }}
          onClick={handleLogin}
          disabled={submitDisabled}
          loading={submitting}
        >
          Webclock
        </Button>
        <Button
          id="sc-employee_portal_button"
          size="large"
          variant="outlined"
          sx={{ width: isMobile ? '100%' : '50%' }}
          onClick={() => handleLogin(false)}
          disabled={submitDisabled}
          loading={submitting}
        >
          Employee Portal
        </Button>
        <Button
          id="sc-forgot_password_button"
          size="medium"
          variant="text"
          sx={{ width: isMobile ? '100%' : '50%' }}
          onClick={handleForgotPassword}
        >
          Forgot Password?
        </Button>
      </ButtonSetWrapper>
    </>
  );
}

BottomButtons.propTypes = {
  loginBag: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
  handleLogin: PropTypes.func.isRequired,
  isAutofilled: PropTypes.bool,
};
